<template>
    <div>
      <h1 class="text-success">Formulario por Trimestre ETMI</h1>
      <div class="alert alert-info" role="alert">
      <strong>Nota:</strong> Estas opciones de trimestre ETMI se agregaran al listado dentro del formulario(mujer) Estrategia nacional para la eliminación de la transmisión materno - infantil
    </div>
      <div class="mt-4">
        <button @click="showCreateForm" class="btn btn-primary">Agregar Nombre del Trimestre</button>
      </div>
  
      <!-- Lista de ETMItrimestres en una tabla -->
      <div class="table-responsive mt-3">
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th>Nombre del Trimestre</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="etmitrimestre in etmitrimestres" :key="etmitrimestre._id">
              <td>{{ etmitrimestre.trimestre }}</td>
              <td>
                <div class="btn-group" role="group">
                  <button @click="editETMItrimestre(etmitrimestre)" class="btn btn-warning btn-sm">Editar</button>
                  <button @click="deleteETMItrimestre(etmitrimestre._id)" class="btn btn-danger btn-sm">Eliminar</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <!-- Formulario de creación/editar -->
      <div v-if="showForm" class="mt-4">
        <h2 class="h4">{{ isEditing ? 'Editar ETMItrimestre' : 'Agregar ETMItrimestre' }}</h2>
        <form @submit.prevent="isEditing ? updateETMItrimestre() : createETMItrimestre()" class="form-inline">
          <div class="form-group mr-2">
            <label for="trimestre" class="mr-2">Trimestre</label>
            <input v-model="formData.trimestre" type="text" id="trimestre" required class="form-control form-control-lg" />
          </div>
          <div class="btn-group">
            <button type="submit" class="btn btn-primary">{{ isEditing ? 'Guardar Cambios' : 'Agregar' }}</button>
            <button @click="cancelEdit" class="btn btn-secondary">Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import swal from 'sweetalert';
  import { BASE_URL } from '../store/config';
  
  export default {
    computed: {
      currentUser() {
        return this.$store.state.auth.user;
      },
    },
    data() {
      return {
        etmitrimestres: [],
        showForm: false,
        formData: {
          trimestre: '',
        },
        isEditing: false,
        editingETMItrimestreId: null,
      };
    },
    methods: {
      async fetchETMItrimestres() {
        try {
          const response = await axios.get(`${BASE_URL}/api/etmitrimestre`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          this.etmitrimestres = response.data;
        } catch (error) {
          console.error('Error al obtener ETMItrimestres:', error);
        }
      },
      showCreateForm() {
        this.showForm = true;
        this.isEditing = false;
        this.formData = {
          trimestre: '',
        };
      },
      async createETMItrimestre() {
        try {
          await axios.post(`${BASE_URL}/api/etmitrimestre`, this.formData, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Guardada!',
            text: 'La información de ETMItrimestre ha sido guardada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.clearFields();
          this.fetchETMItrimestres();
          this.showForm = false;
        } catch (error) {
          swal({
            title: 'Error',
            text: `Hubo un error al guardar la información de ETMItrimestre. \n ${error.response.data.message}.`,
            icon: 'error',
            button: 'OK',
          });
        }
      },
      clearFields() {
        this.formData = {
          trimestre: '',
        };
      },
      deleteETMItrimestre(id) {
        swal({
          title: '¿Estás seguro?',
          text: 'Una vez eliminado, no podrás recuperar este registro.',
          icon: 'warning',
          buttons: ['Cancelar', 'Eliminar'],
          dangerMode: true,
        })
        .then((confirmation) => {
          if (confirmation) {
            this.performETMItrimestreDeletion(id);
          }
        });
      },
      async performETMItrimestreDeletion(id) {
        try {
          await axios.delete(`${BASE_URL}/api/etmitrimestre/${id}`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Eliminada!',
            text: 'La información de ETMItrimestre ha sido eliminada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.fetchETMItrimestres();
        } catch (error) {
          swal({
            title: 'Error',
            text: 'Hubo un error al eliminar la información de ETMItrimestre.',
            icon: 'error',
            button: 'OK',
          });
        }
      },
      editETMItrimestre(etmitrimestre) {
        this.isEditing = true;
        this.editingETMItrimestreId = etmitrimestre._id;
        this.formData.trimestre = etmitrimestre.trimestre;
        this.showForm = true;
      },
      async updateETMItrimestre() {
        try {
          await axios.put(`${BASE_URL}/api/etmitrimestre/${this.editingETMItrimestreId}`, this.formData, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Actualizada!',
            text: 'La información de ETMItrimestre ha sido actualizada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.clearFields();
          this.fetchETMItrimestres();
          this.showForm = false;
        } catch (error) {
          swal({
            title: 'Error',
            text: `Hubo un error al editar la información de ETMItrimestre. \n ${error.response.data.message}.`,
            icon: 'error',
            button: 'OK',
          });
        }
      },
      cancelEdit() {
        this.showForm = false;
        this.isEditing = false;
        this.clearFields();
      },
    },
    mounted() {
      this.fetchETMItrimestres();
    },
  };
  </script>
  
  <style scoped>
  /* Estilos adicionales si es necesario */
  </style>
  